import React from "react";

function ComplaintsAndMails() {
  return (
    <div>
      <h1>Complaints And Mails</h1>
    </div>
  );
}

export default ComplaintsAndMails;
